/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2025-10-10 18:20:25
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2026-01-22 18:04:32
 * @FilePath: /polordar-explorer/ui/snippets/topBar/TopBar.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Flex, Separator, Box, Button, Menu, Portal } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { useTranslation } from 'lib/i18n/LanguageContext';
import IconSvg from 'ui/shared/IconSvg';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

import ConnectWalletButton from './ConnectWalletButton';
import DeFiDropdown from './DeFiDropdown';
import NetworkMenu from './NetworkMenu';
import Settings from './settings/Settings';
import TopBarStats from './TopBarStats';

const TopBar = () => {
  const { lang, setLang, t } = useTranslation();
  return (
    // not ideal if scrollbar is visible, but better than having a horizontal scroll
    <Box
      bgColor={{
        _light: 'theme.topbar.bg._light',
        _dark: 'theme.topbar.bg._dark',
      }}
      position="sticky"
      left={ 0 }
      width="100%"
      maxWidth="100vw"
    >
      <Flex
        py={ 2 }
        px={{ base: 3, lg: 6 }}
        m="0 auto"
        justifyContent="space-between"
        alignItems="center"
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
      >
        { !config.features.opSuperchain.isEnabled ? <TopBarStats/> : <div/> }
        <Flex alignItems="center">
          { config.features.deFiDropdown.isEnabled && (
            <>
              <DeFiDropdown/>
              <Separator
                mr={ 3 }
                ml={{ base: 2, sm: 3 }}
                height={ 4 }
                orientation="vertical"
              />
            </>
          ) }

          <Menu.Root>
            <Menu.Trigger asChild>
              <Button variant="outline" size="sm" rounded="full" marginRight={ 3 }>
                <IconSvg
                  name={ lang === 'zh' ? 'local/zh' : 'local/en' }
                  boxSize={ 6 }
                />
                { lang === 'zh' ? t('settings.language.zh') : t('settings.language.en') }
              </Button>
            </Menu.Trigger>
            <Portal>
              <Menu.Positioner>
                <Menu.Content>
                  <Menu.Item value="lang-en" onClick={ () => setLang('en') }>
                    <IconSvg
                      name="local/en"
                      boxSize={ 6 }
                    />
                    English
                  </Menu.Item>
                  <Menu.Item value="lang-zh" onClick={ () => setLang('zh') }>
                    <IconSvg
                      name="local/zh"
                      boxSize={ 6 }
                    />
                    简体中文
                  </Menu.Item>
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>
          <ConnectWalletButton/>
          <Settings/>
          { Boolean(config.UI.featuredNetworks.items) && (
            <>
              <Separator mx={ 3 } height={ 4 } orientation="vertical"/>
              <NetworkMenu/>
            </>
          ) }
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(TopBar);
